import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, AxiosProgressEvent } from 'axios';
import { RUMHelpers, PIIRedactor } from 'services/observability/datadog';

export type ApiResponse<T = any> = AxiosResponse<T>;
export type ApiRequest = AxiosRequestConfig;
export type ApiError<T = any> = AxiosError<T>;
export type ApiProgressEvent = AxiosProgressEvent;
export const ApiError = AxiosError;

export enum ApiMethod {
  get = 'GET',
  delete = 'DELETE',
  post = 'POST',
  put = 'PUT',
  patch = 'PATCH',
}

const axiosConfig: AxiosRequestConfig = {
  paramsSerializer: {
    // our backend only accepts array entries in params, i.e. memberFilterIds: [EMAIL1, EMAIL2],
    // in the following way: memberFilterId=EMAIL1&memberFilterId=EMAIL2.
    // by default however, axios sends it as memberFilterId[]=EMAIL1&memberFilterId[]=EMAIL2.
    // indexes: null, here, sets the param serialzer to the way we want.
    indexes: null,
  },
};

export const api = axios.create(axiosConfig);

// Intercepts https responses so that actions can be taken on any successful or
// failed requests (e.g. logging, error handling, etc.)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { message, code, config, response, stack } = error;
    const err = new Error(PIIRedactor.fromString(message || ''));
    err.name = 'AxiosError';
    err.stack = stack;

    const info = {
      code,
      url: config.url,
      status: response.status,
      statusText: response.statusText,
      data: response.data,
    };

    RUMHelpers.addRUMError(err, 'AXIOS_ERROR', info);

    return Promise.reject(error);
  },
);

export type ErrorHttpResponse = {
  code: string;
  data: any;
  error: string;
  message: string;
};
